import dateFormat from '@/utils/dateFormat';

const columns = () => ([
  {
    title: 'Preview',
    dataIndex: 'imageUrl',
    key: 'imageUrl',
    width: '10%',
    align: 'center',
  },
  {
    title: 'Title',
    dataIndex: 'name',
    key: 'name',
    customRender: ({ text }) => (`${text.length > 35 ? `${text.slice(0, 32)}...` : text}`),
  },
  {
    title: 'Title SEO',
    dataIndex: 'seoTitle',
    key: 'seoTitle',
    customRender: ({ text }) => (`${text.length > 35 ? `${text.slice(0, 32)}...` : text}`),
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    customRender: ({ text }) => (`${text.length > 35 ? `${text.slice(0, 32)}...` : text}`),
  },
  {
    title: 'Description SEO',
    dataIndex: 'seoDescription',
    key: 'seoDescription',
    customRender: ({ text }) => (`${text.length > 35 ? `${text.slice(0, 32)}...` : text}`),
  },
  {
    title: 'Summary description',
    dataIndex: 'summeryDescription',
    key: 'summeryDescription',
    customRender: ({ text }) => (`${text.length > 35 ? `${text.slice(0, 32)}...` : text}`),
  },
  {
    title: 'URL',
    dataIndex: 'url',
    key: 'url',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Update date',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    width: '10%',
    customRender: ({ text }) => dateFormat(text, 'DD-MM-YYYY HH:MM'),
  },
  {
    title: 'Orders',
    dataIndex: 'index',
    key: 'orders',
    align: 'center',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: '10%',
    align: 'center',
  },
]);

export default columns;
